module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAARCAYAAAAL4VbbAAAAAXNSR0IArs4c6QAAAM5JREFUKBWFkMsLQUEUhyc2Esorj5IsLaQssKBk4X9nYWFjQd0iSjbyymNxfb+ahcVMc+rr3Dvn+02dMSZQcRzXIBvQjEFqwxtUZW+AYQcu8AVV0ikz6MEVJJ6g6ROHDG9WPNIbPnFsxQ99D3WfOGX4AIkRVHxi30rafAvuzRlUQSVxBwXnjRwm4GyH+i5Cy/67G7elIQLdrpcYuE17ilCCDShwh1EokEda/wUmoUAOeQUv0FPOQoEM0tIGnvRuKKCl56AdVNVQIIW0gIPEHzNECmTjghTdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/chevron-white-thick-left.png
// module id = 1775
// module chunks = 51